module.exports = "div.custom-style {\r\n  border: 1px solid #d7d7d7;\r\n  border-radius: 12px;\r\n  box-shadow: 0.5px 0.5px 1px 0 rgba(0, 0, 0, 0.2);\r\n}\r\n"